module.exports = __webpack_public_path__ + "img/devbox33.6c0d2204.png";